import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import post from '@/router/routes/post';
import keywords from '@/router/routes/keywords';
import clinicianRoutes from '@/router/routes/clinicianRoutes';
import printQueueUserRoutes from '@/router/routes/printQueueUserRoutes';
import replies from '@/router/routes/replies';
import digitalReplies from '@/router/routes/digitalReplies';
import digitalMailRestrictionRoutes from '@/router/routes/digitalMailRestrictionRoutes';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...replies,
    ...post,
    ...keywords,
    ...clinicianRoutes,
    ...printQueueUserRoutes,
    ...digitalReplies,
    ...digitalMailRestrictionRoutes,
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        clinicianBlocked: true,
        printQueueUserBlocked: true,
        protected: true,
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/bans',
      name: 'bans',
      component: () => import('@/views/bannedUsers/BannedUsers.vue'),
      meta: {
        clinicianBlocked: true,
        printQueueUserBlocked: true,
        protected: true,
        pageTitle: 'Banned External Users',
        breadcrumb: [
          {
            text: 'Banned external users',
            active: true,
          },
        ],
      },
    },
    {
      path: '/locations',
      name: 'locations',
      component: () => import('@/views/prisonerLocations/PrisonerLocations.vue'),
      meta: {
        clinicianBlocked: true,
        printQueueUserBlocked: true,
        protected: true,
        pageTitle: 'Site Locations',
        breadcrumb: [
          {
            text: 'Site Locations',
            active: true,
          },
        ],
      },
    },
    {
      path: '/mail-monitors',
      name: 'mail-monitors',
      component: () => import('@/views/mailMonitors/MailMonitors.vue'),
      meta: {
        clinicianBlocked: true,
        printQueueUserBlocked: true,
        protected: true,
        pageTitle: 'Mail Monitors',
        breadcrumb: [
          {
            text: 'Mail Monitors',
            active: true,
          },
        ],
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: {
        protected: true,
        pageTitle: 'Profile',
        breadcrumb: [
          {
            text: 'Profile',
            active: true,
          },
        ],
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('userTokenPost');
  let user = localStorage.getItem('userPost');

  if (user) {
    user = JSON.parse(user);
  }

  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
  const loggedIn = !!token;
  // Authed routes that do not allow unauthed users
  if (!loggedIn && to.meta.protected) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }

  if (to.meta.clinicianBlocked && user && user.is_clinician) {
    next({
      name: 'clinician-dashboard',
    });
  }

  if (to.meta.printQueueUserBlocked && user && user.is_print_queue_user) {
    next({
      name: 'print-queue-dashboard',
    });
  }

  // UnAuthed routes that do not allow authed users
  if (loggedIn && to.meta.redirectAuthed) {
    next({
      path: '/dashboard',
    });
  }
  next();
});

export default router
